<template>
  <ButtonBase
    class="button-pill"
    :class="{ 'button-pill__has-icon': !!iconComponent }"
    v-bind="$attrs"
    :style="{ animationDelay }"
    v-on="$listeners"
  >
    <div class="button-pill_inner">
      <component :is="iconComponent" class="button-pill__icon" />
      <slot />
    </div>
  </ButtonBase>
</template>

<script>
import ButtonBase from '../ButtonBase';

const ICONS = {
  fullscreen: () => import('../../assets/icons/fullscreen.svg?inline'),
};

export default {
  name: 'ButtonPill',

  components: {
    ButtonBase,
  },

  props: {
    icon: {
      type: String,
      default: undefined,
      validator: (icon) => Object.keys(ICONS).includes(icon),
    },
  },

  data() {
    return {
      animationDelay: `${Math.random() * 2}s`,
    };
  },

  computed: {
    iconComponent() {
      return ICONS[this.icon];
    },
  },
};
</script>

<style lang="scss" scoped>
$horizontal-padding: 30px;
$vertical-padding: 15px;
$line-heigth: 16px;

.button-pill {
  position: relative;
  display: block;
  padding: $vertical-padding $horizontal-padding;
  min-width: 150px;
  max-width: 250px;
  border-radius: $vertical-padding * 2 + $line-heigth;
  @include linear-gradient($color-purple, $color-blue, 45deg);
  text-align: center;
  @include font-rem(14px, $line-heigth);
  color: $color-white;
  transition: 0.3s ease;
  background-size: 150% 150%;
  animation: moveBackground 3s ease infinite;
  cursor: pointer;
  @include helper__composited-layer();

  &:hover {
    transform: scale(1.02);
    background-position: 0% 0%;
  }

  &:active {
    transform: scale(0.98);
    opacity: 0.8;
  }
}

// animation made with https://www.gradient-animator.com/
@keyframes moveBackground {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.button-pill_inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-pill[disabled] {
  opacity: 0.4;
  cursor: not-allowed;

  &:hover {
    transform: scale(1);
  }
}

.button-pill__icon {
  width: 22px;
  height: 22px;
  margin-right: $horizontal-padding - $vertical-padding / 2;
}
</style>
